/** @module csi/heading/_LocalizedMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action",
	"csi/def/Action",
	"csi/html",
	"csi/locale",
	"csi/state"
], function(declare,lang,_,csiAction,Action,html,locale,state) {

	var	TOOLTIP_COMMENT = '<div class="csi-localized-string-tooltip"><label>${LocalizedStringLocalizations:_nls}:</label><div>${0}</div></div>';

	csiAction.registerControllers("", {
		ActionLocalizedStringPopup: "csi/heading/LocalizedStringPopupController"
	});

	return declare(null, {
		bBaseRenderer: true,
		bSupportContainerKeyTooltip: true,

		/** @property {boolean} useSiteLocale - if true, then use site locale rather than context locale */
		useSiteLocale: false,

		/**
		 * Set current locale as index for query spec
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.index = this._getLocale(ctx);
			return qs;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: assign current locale to context if none provided
			// FIX: eventually the Spec index should be assigned to the locale, and then this will no longer be necessary; we would need all views to use Spec though
			if (!ctx.keyValue) {
				ctx.__previousKey = ctx.keyValue;
				ctx.keyValue = this._getLocale(ctx);
			}

			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: reset context
			if (ctx.__previousKey != null) {
				ctx.keyValue = ctx.__previousKey;
				ctx.__previousKey = null;
			}

			this.inherited(arguments);
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: show existing values in different locales
			var node = ctx.getNode();
			if (!node) {
				return;
			}

			this.inherited(arguments);

			var keys = _.reduce(node[h.m_id], function(memo, value, key) {
				if (value && (key != ctx.keyValue)) {
					memo.push(locale.resource(key));
				}

				return memo;
			}, []);

			if (!ctx.bPopup) {
				tooltip.addAction(this._mixinTooltipAction(lang.mixin(new Action(), {
					m_id: "ActionLocalizedStringPopup"
				}), h, true));
			}

			if (keys.length) {
				tooltip.addContent(html.stringToDom(TOOLTIP_COMMENT, [keys.join(", ")]));
			}
		},

		/**
		 * Return locale to use for renderer
		 * @param {Context}
		 * @return {string}
		 */
		_getLocale: function(ctx) {
			return this.useSiteLocale ? state.get("siteLocale") : (ctx.locale || locale.getLocale());
		},
		
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: throw exception if ctx does not have keyValue
			if (!ctx.keyValue) {
				throw new Error("Localized string renderer requires ctx.keyValue set to desired locale.");
			}

			return this.inherited(arguments);
		}
	});
});